import { TopolRawBlock } from "@/schemas/template/blocks/rawBlockSchema";
import { v4 as uuidv4 } from "uuid";

export default {
  getData(): TopolRawBlock {
    return {
      uid: uuidv4(),
      tagName: "mj-raw",
      attributes: {
        containerWidth: 600,
      },
      content:
        '<span style="font-size: 11px;">\nNapi\u0161te kr\u00e1tk\u00e9 shrnut\u00ed va\u0161eho e-mailu, \ntzv. "preheader"\n</span>',
    };
  },
};
